module.exports = __webpack_public_path__ + "static/media/1.45e56070.jpg";